import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

import { ConditionOptionsType } from '~/constants/automationRuleForm';
import AutomationRuleError, { EMPTY_RULE_ERROR } from '~/types/AutomationRuleError';
import BusinessRule from '~/types/BusinessRule';

export type AutomationsState = {
  readonly businessRules: BusinessRule[];
  readonly associatedPackageTemplateIds: string[];
  readonly deleteRuleModalIsOpen: boolean;
  readonly addRuleModalIsOpen: boolean;
  readonly selectedFilterGroupId: number;
  readonly selectedUserParcelTemplateObjectId: string;
  readonly error: AutomationRuleError;
  readonly reprocessRuleStatus: string;
  readonly closedReprocessingPendingNotification: boolean;
  readonly closedReprocessingCompleteNotification: boolean;
  readonly disabledConditionOptionsList: ConditionOptionsType;
};

const initialState: AutomationsState = {
  businessRules: [],
  associatedPackageTemplateIds: [],
  deleteRuleModalIsOpen: false,
  addRuleModalIsOpen: false,
  selectedFilterGroupId: 0,
  selectedUserParcelTemplateObjectId: '0',
  error: EMPTY_RULE_ERROR,
  reprocessRuleStatus: '',
  closedReprocessingPendingNotification: false,
  closedReprocessingCompleteNotification: false,
  disabledConditionOptionsList: {},
};

function automationsReducer(
  state: AutomationsState = initialState,
  action: ActionTypes,
): AutomationsState {
  switch (action.type) {
    case ActionKeys.FETCH_BUSINESS_RULES_SUCCESS:
      return {
        ...state,
        businessRules: action.payload.businessRules,
        associatedPackageTemplateIds: action.payload.associatedPackageTemplateIds,
      };
    case ActionKeys.AUTOMATIONS_OPEN_DELETE_MODAL:
      return {
        ...state,
        deleteRuleModalIsOpen: true,
      };
    case ActionKeys.AUTOMATIONS_CLOSE_DELETE_MODAL:
      return {
        ...state,
        deleteRuleModalIsOpen: false,
      };
    case ActionKeys.AUTOMATIONS_DELETE_RULE_SUCCESS:
      return {
        ...state,
        deleteRuleModalIsOpen: false,
      };
    case ActionKeys.AUTOMATIONS_DELETE_RULE_ERROR:
      return {
        ...state,
        deleteRuleModalIsOpen: false,
      };
    case ActionKeys.AUTOMATIONS_OPEN_ADD_RULE_MODAL:
      return {
        ...state,
        addRuleModalIsOpen: true,
      };
    case ActionKeys.AUTOMATIONS_CLOSE_ADD_RULE_MODAL:
      return {
        ...state,
        addRuleModalIsOpen: false,
      };
    case ActionKeys.AUTOMATIONS_CHANGE_SELECTED_FILTER_GROUP:
      return {
        ...state,
        selectedFilterGroupId: action.payload.filterGroupId,
      };
    case ActionKeys.AUTOMATIONS_CHANGE_SELECTED_USER_PARCEL_TEMPLATE:
      return {
        ...state,
        selectedUserParcelTemplateObjectId: action.payload.userParcelTemplateObjectId,
      };
    case ActionKeys.AUTOMATIONS_CREATE_RULE_SUCCESS:
      return {
        ...state,
      };
    case ActionKeys.AUTOMATIONS_SET_RULE_ERROR:
      return {
        ...state,
        error: action.payload.error,
      };
    case ActionKeys.AUTOMATIONS_REORDER_RULES_SUCCESS:
      return {
        ...state,
        businessRules: action.payload.rules,
      };
    case ActionKeys.AUTOMATIONS_UPDATE_REPROCESS_STATUS:
      return {
        ...state,
        reprocessRuleStatus: action.payload.status,
      };
    case ActionKeys.AUTOMATIONS_CLOSE_RULE_REPROCESS_PENDING_NOTIF:
      return {
        ...state,
        closedReprocessingPendingNotification: true,
      };
    case ActionKeys.AUTOMATIONS_CLOSE_RULE_REPROCESS_COMPLETE_NOTIF:
      return {
        ...state,
        closedReprocessingCompleteNotification: true,
      };
    case ActionKeys.AUTOMATIONS_RESET_RULE_REPROCESS_PENDING_NOTIF:
      return {
        ...state,
        closedReprocessingPendingNotification: false,
      };
    case ActionKeys.AUTOMATIONS_RESET_RULE_REPROCESS_COMPLETE_NOTIF:
      return {
        ...state,
        closedReprocessingCompleteNotification: false,
      };
    case ActionKeys.AUTOMATIONS_UPDATE_DISABLED_CONDITION_OPTIONS_LIST:
      return {
        ...state,
        disabledConditionOptionsList: action.payload,
      };
    default:
      return state;
  }
}

export default automationsReducer;
